import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const SlippageTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      {t('Your transaction will revert if there is a large, unfavorable price movement before it is confirmed.')}
    </TooltipBase>
  )
}
